import React from 'react';
import './ResultsStates.css';

export interface ResultsSkeletonProps {
  /** Nombre de cartes fantômes à afficher (défaut : 4). */
  count?: number;
}

/**
 * Rangée de cartes fantômes (shimmer) affichée pendant le calcul des résultats
 * (SPEC §4.5). Purement présentationnel — aucune logique de données.
 * Le shimmer est désactivé sous `prefers-reduced-motion` (placeholders statiques).
 */
export const ResultsSkeleton: React.FC<ResultsSkeletonProps> = ({ count = 4 }) => {
  return (
    <div className="results-skeleton" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="results-skeleton__card">
          <div className="results-skeleton__title" />
          <div className="results-skeleton__image" />
          <div className="results-skeleton__button" />
        </div>
      ))}
    </div>
  );
};

export default ResultsSkeleton;
